import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { motion } from "framer-motion";
import "./FAQSection.css";

const faqData = [
  {
    question: "How can I book a trip?",
    answer:
      "You can book a trip via our website by selecting a package, filling out the booking form, or contacting our support team directly.",
  },
  {
    question: "What is your cancellation policy?",
    answer:
      "You can cancel your booking up to 7 days before departure for a full refund. Charges apply for cancellations after this period.",
  },
  {
    question: "Do you provide customized travel plans?",
    answer:
      "Yes, we tailor itineraries according to your preferences, budget, and travel dates.",
  },
  {
    question: "Can I modify my booking?",
    answer:
      "Yes, you can modify your booking up to 5 days before departure. Additional charges may apply.",
  },
  {
    question: "Are group discounts available?",
    answer:
      "Yes, we provide special rates for group bookings. Please contact our sales team for details.",
  },
  {
    question: "Do you provide visa assistance?",
    answer:
      "Yes, we offer complete visa assistance for international trips, including documentation guidance and support.",
  },
  {
    question: "Do you provide travel insurance?",
    answer:
      "Yes, we offer travel insurance for all our packages to ensure a safe journey.",
  },
  {
    question: "How long does it take to confirm a booking?",
    answer:
      "Bookings are confirmed immediately upon payment. For custom packages, confirmation may take 24-48 hours.",
  },
  {
    question: "Do you have special packages for families?",
    answer:
      "Yes, our family packages include kid-friendly activities and family accommodations.",
  },
  {
    question: "Do you arrange airport transfers?",
    answer:
      "Yes, airport pickups and drop-offs can be arranged for all bookings.",
  },
  {
    question: "What types of corporate events do you manage?",
    answer:
      "We manage conferences, team-building events, retreats, award ceremonies, and corporate trips.",
  },
  {
    question: "Do you provide event venue recommendations?",
    answer:
      "Yes, we suggest venues based on your budget, location, and event requirements.",
  },
  {
    question: "Can you handle international corporate trips?",
    answer:
      "Absolutely, we manage travel, accommodation, and event logistics for international corporate trips.",
  },
  {
    question: "Do you provide catering services for events?",
    answer:
      "Yes, we collaborate with trusted vendors to provide catering for corporate events.",
  },
  {
    question: "Can you arrange team-building activities?",
    answer:
      "Yes, we plan customized team-building exercises and workshops to suit your objectives.",
  },
  {
    question: "How far in advance should I book a corporate event?",
    answer:
      "Ideally, 4-6 weeks for domestic events and 3-4 months for international events.",
  },
  {
    question: "Do you handle event registrations and attendee management?",
    answer:
      "Yes, we can manage RSVPs, registrations, and attendee communication.",
  },
  {
    question: "Can you provide audio-visual support for events?",
    answer:
      "Yes, we provide projectors, screens, sound systems, and technical assistance.",
  },
  {
    question: "Do you manage corporate event transportation?",
    answer:
      "Yes, we arrange buses, shuttles, or private vehicles for your event attendees.",
  },
  {
    question: "Can you create event branding and decoration?",
    answer:
      "Yes, we provide full branding, décor, and theme-based setup services.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept credit/debit cards, net banking, UPI, and corporate payment gateways.",
  },
  {
    question: "Is there 24/7 support available during trips?",
    answer:
      "Yes, our support team is available 24/7 for assistance during your travel or event.",
  },
  {
    question: "Can I request invoices for corporate bookings?",
    answer: "Yes, we provide GST-compliant invoices for all corporate clients.",
  },
  {
    question: "Do you offer last-minute bookings?",
    answer:
      "Yes, depending on availability, we can accommodate last-minute travel or event bookings.",
  },
  {
    question: "How do I provide feedback or suggestions?",
    answer:
      "You can share feedback via our website, email, or by contacting our support team directly.",
  },
];

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);
  const [visibleCount, setVisibleCount] = useState(3);

  const toggleAnswer = (index) =>
    setOpenIndex(openIndex === index ? null : index);
  const handleLoadMore = () =>
    setVisibleCount((prev) => Math.min(prev + 3, faqData.length));
  const handleShowLess = () => setVisibleCount(3);

  const visibleFaqs = faqData.slice(0, visibleCount);

  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 120, damping: 20 },
    },
  };

 return (
  <div className="faq-container">
    <h2 className="faq-heading">FAQ</h2>

    <div className="faq-list">
      {visibleFaqs.map((item, index) => (
        <div key={index} className="faq-item">
          <div className="faq-question" onClick={() => toggleAnswer(index)}>
            <span>{item.question}</span>
            <span className="faq-icon">
              {openIndex === index ? <FaMinus /> : <FaPlus />}
            </span>
          </div>
          {openIndex === index && (
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>

    <div className="faq-buttons">
      {visibleCount < faqData.length && (
        <button className="faq-load-more" onClick={handleLoadMore}>
          Load More
        </button>
      )}
      {visibleCount > 3 && (
        <button className="faq-show-less" onClick={handleShowLess}>
          Show Less
        </button>
      )}
    </div>
  </div>
);

}

export default FAQSection;
